/**
 * NPS.ACTIONS
 * Route for net promoter score calculation
 */

import { DashboardFilters } from "./filter.types"

export const fetchNps = (dashboardFilters: DashboardFilters, isReport: boolean = false) => ({
  type: "ARCHIVE",
  payload: {
    url: "/nps",
    dashboardFilters,
    data: {
      isReport
    }
  }
})

export const fetchNpsHeatmap = (
  dashboardFilters: DashboardFilters,
  questionAid: number,
  filterName: string,
  dateCeils: string,
  isReport: boolean = false
) => ({
  type: "ARCHIVE",
  payload: {
    url: "/nps/heatmap",
    dashboardFilters,
    data: {
      questionAid,
      filterName,
      dateCeils,
      isReport
    }
  }
})
